// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { CourseUnion } from './course-union';
import { User } from './user';

/**
 * 
 * @export
 * @interface CourseListenerUnion
 */
export interface CourseListenerUnion {
    /**
     * 
     * @type {string}
     * @memberof CourseListenerUnion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CourseListenerUnion
     */
    version: CourseListenerUnionVersionEnum;
    /**
     * 
     * @type {CourseUnion}
     * @memberof CourseListenerUnion
     */
    course: CourseUnion;
    /**
     * 
     * @type {User}
     * @memberof CourseListenerUnion
     */
    user: User;
    /**
     * 
     * @type {boolean}
     * @memberof CourseListenerUnion
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CourseListenerUnion
     */
    success?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof CourseListenerUnion
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CourseListenerUnion
     */
    passedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof CourseListenerUnion
     */
    status: CourseListenerUnionStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CourseListenerUnion
     */
    learningCompleted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CourseListenerUnion
     */
    testCompleted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CourseListenerUnion
     */
    practiceCompleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof CourseListenerUnion
     */
    studentId?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseListenerUnion
     */
    studentFullName?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CourseListenerUnionVersionEnum {
    V1 = 'v1',
    V2 = 'v2'
}
/**
    * @export
    * @enum {string}
    */
export enum CourseListenerUnionStatusEnum {
    Learning = 'learning',
    Success = 'success',
    NotSuccess = 'not_success'
}



